import { useEffect, useState } from 'react';
import { db } from '../db/local.js';
import { today } from '../db/nutrition.js';
import { readProfile } from '../db/profile.js';

/**
 * Zeitzone des Profils. `null`, bis sie gelesen ist — wer rechnet, wartet
 * darauf oder nennt ausdrücklich einen Ersatz (`useTimeZone() ?? …`).
 *
 * Eine Stelle für die Regel „gerechnet wird in der Zeitzone des Nutzers"
 * (CLAUDE.md): Vorher lasen zehn Komponenten das Profil je für sich.
 */
export function useTimeZone(): string | null {
  const [timeZone, setTimeZone] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    void readProfile(db).then((profile) => {
      if (alive) setTimeZone(profile.timezone);
    });
    return () => {
      alive = false;
    };
  }, []);
  return timeZone;
}

/** Heutiger Kalendertag in der Zeitzone des Profils — `null`, bis bekannt. */
export function useToday(): string | null {
  const timeZone = useTimeZone();
  return timeZone ? today(timeZone) : null;
}
